import { gql } from '../../gql-tag';

export const GET_PHONE_LINE_POLICY = gql(`
  query getPhoneLinePolicy($phoneLinePolicyId: String!) {
    phoneLinePolicy(phoneLinePolicyId: $phoneLinePolicyId) {
      ...PhoneLinePolicyFields
    }
  }
`);
